/**
 * Attach a full ancestral key
 * It can be used to quickly locate tags from the root of the tree
 * @param {*} tree Custom tag tree
 * @returns A Custom tree with ancestral key attached
 */
export const attachAncestryKeyToTree = (tree) => {
  const copyOfTree = JSON.parse(JSON.stringify(tree));

  const attachKey = (listOfTags, parentKey) => {
    return listOfTags.map((tag) => {
      const key = parentKey ? `${parentKey}-${tag._id}` : tag._id;
      const children = attachKey(tag.children || [], key);
      return {
        ...tag,
        key,
        children,
      };
    });
  };

  return attachKey(copyOfTree);
};
